/* istanbul ignore file */
export const getTodaysDate = () => {
  const date = new Date();
  return date.toISOString().substring(0, 10);
};

export const getFormatDate = (date: Date) => {
  return new Date(date).toISOString().substring(0, 10);
};

/**
 * Parses date strings in MM/DD/YYYY format to Date objects
 * Falls back to standard Date parsing for other formats
 */
export const parseDateString = (dateString: string): Date => {
  if (dateString.includes('/')) {
    // Handle MM/DD/YYYY format
    const [month, day, year] = dateString.split('/');
    return new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
  }
  // ISO date-only values represent a calendar date, not a UTC timestamp. Parse
  // them with local calendar fields so date ranges do not shift a day for users
  // west of UTC when displayed in their locale.
  const isoDateMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateString);
  if (isoDateMatch) {
    const [, year, month, day] = isoDateMatch;
    return new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
  }
  // Handle date-time strings and other standard formats.
  return new Date(dateString);
};
